<template>
  <CrudList
    title="Cupones"
    storeName="Coupons"
    labelAddNew="Agregar"
    next-link="/admin/notifications_request_cms"
  :breadcrumbs="[
      {
          text: 'Marketing y comunicación',
          disabled: false,
          href: '#',
        },
        {
          text: 'Cupones',
          disabled: false,
          href: '#',
        }
    ]"
    sortable
    canSearch
  >
    <template v-slot:user_coupons="{item}">
      <v-btn
          elevation="0"
          class="my-1 btn-black btn-round-md"
          rounded
          color="primary"
          @click="$router.push('/admin/coupons/' + item.id + '/user_coupons')"
      >
        Cupones <br> de Usuario
      </v-btn>
    </template>
    <template v-slot:head_item="{}">
      <v-btn
          elevation="0"
          text
          @click="$router.push('/admin/coupons_bulk/add')"
      >
      Crear Cupones para Usuarios
      </v-btn>
    </template>
  </CrudList>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: { CrudList },
};
</script>
